<script>
import Draggable from 'vuedraggable';
import converter from '../../utils/converter';
import ItineraryDayProgramImage from './ItineraryDayProgramImage';

export default {
  name: 'ItineraryDayProgramImageList',
  components: {
    ItineraryDayProgramImage,
    Draggable,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localImages: [],
    };
  },
  created() {
    this.localImages = [...this.images];
  },
  methods: {
    move({ moved }) {
      this.localImages = converter.arrayMove(this.localImages, moved.oldIndex, moved.newIndex);
      this.$emit('move', this.localImages);
    },
    remove(index) {
      this.$emit('remove', this.images[index]);
    },
    delete(event) {
      this.$emit('delete', event);
    },
  },
  watch: {
    images(val) {
      if (val) {
        this.localImages = [...val];
      }
    },
  },
};
</script>

<template>
  <v-container
    grid-list-sm
    fluid
    text-xs-center
  >
    <v-layout
      row
      wrap
      align-center
    >
      <v-card
        class="mx-auto"
        min-width="100%"
        min-height="135"
      >
        <draggable
          :value="localImages"
          class="xs12 itinerary-day-program-image-list-draggable"
          @change="move"
        >
          <transition-group name="list-complete">
            <v-flex
              v-for="(image, index) in localImages"
              :key="`itinerary-day-program-image-${index}`"
              class="itinerary-day-program-image-list-draggable-item"
              xs4
              d-flex
            >
              <v-card>
                <itinerary-day-program-image
                  :src="image.original"
                  :thumbnail="image.thumbnail"
                  @update="$emit('update', {index: index, image: {...image, ...$event }})"
                  @remove="remove(index)"
                />
                <template v-slot:placeholder>
                  <v-layout
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  />
                </template>
              </v-card>
            </v-flex>
          </transition-group>
        </draggable>
        <v-flex
          v-if="!images.length && !loading"
          xs12
          pa-5
        >
          <v-flex>
            <v-icon text--secondary>image</v-icon>
          </v-flex>
          <v-flex
            font-italic
            text--secondary
          >
            {{ $t('itinerary.edit.dayProgram.images.noContent') }}
          </v-flex>
        </v-flex>
        <v-flex
          v-if="loading"
          xs12
          pa-5
          class="itinerary-day-program-image-list-spinner"
        >
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          />
        </v-flex>
      </v-card>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
  @import '../../assets/scss/mixins';
  @import '../../assets/scss/variables';
  @import '../../assets/scss/animations';

  .itinerary-day-program-image-list-draggable {
    width: 100%;
  }

  .itinerary-day-program-image-list-draggable-item {
    float: left;
    width: calc((100% / 5) - #{$margin-xs * 2});
    margin: $margin-xs;
    animation: bounceIn;
    animation-duration: .2s;
    animation-iteration-count: 1;
    transition: all 1s;
    display: inline-block;
  }

  .itinerary-day-program-image-list-spinner {
    @include position-absolute();
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramImageList.vue